import * as React from 'react';
import { useRecordContext } from 'react-admin';

const DimensionsField = () => {
    const record = useRecordContext();
    if (!record) return null;

    const { heightInMtr, widthInMtr, lengthInMtr, weightInGrams } = record;

    return (
        <div className={'text-xs'}>
        <div className={'whitespace-nowrap'}>
            Height: <b>{heightInMtr}m</b>
        </div>
        <div className={'whitespace-nowrap'}>
        Width: <b>{widthInMtr}m</b>
        </div>
        <div className={'whitespace-nowrap'}>
        Length: <b>{lengthInMtr}m</b>
        </div>
        <div className={'whitespace-nowrap'}>
        Weight: <b>{weightInGrams}g</b>
        </div>
        </div>
    );
};

DimensionsField.defaultProps = {
    label: 'Dimensions'
}
export default DimensionsField;
